import { Button } from "antd";
import { IModelMemberInfo } from "../domain/ModelInfos/IModelInfo";
import { when } from "../helpers/tsxHelper";

interface IProps {
    modelMember?: IModelMemberInfo;
    onChange: (changes: Partial<IModelMemberInfo>) => any;
    onClick: () => any;
}
export function ModelMemberTypeEditor(props: IProps) {
    const { modelMember, onClick } = props;
    if (!modelMember) return <></>;
    return <div><Button size="small" style={{ width: "100%" }} onClick={onClick}>{modelMember.type.name} {when(!!modelMember.length, () => <> ({modelMember.length})</>)}</Button></div>
}
